<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import obirimbelge from "@/models/obirimbelge";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, obirimbelge],
  page: {
    title: "Kurum Belgeleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit, treeselect
  },
  data() {
    return {
      title: "Kurum Belgeleri",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kurum Belgeleri",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      FILES_URL: JSON.parse(localStorage.getItem("config")).FILES_URL,
      Filter: {
        Baslik: null,
        Uygulamaid: null,
        Birimid: null,
        Baslangictarihi: null,
        Bitistarihi: null,
      },
    };
  },

  methods: {
    Get() {


      var FilterText = "&Desc="

      if (this.Filter.Baslik != null && this.Filter.Baslik != "" &&
        typeof this.Filter.Baslik === "string" && this.Filter.Baslik.length > 2) {
        FilterText += "&Baslik=" + this.Filter.Baslik
      }

      if (this.Filter.Birimid != null && this.Filter.Birimid != "") {
        FilterText += "&Birimid=" + this.Filter.Birimid
      }




      this.ActionsFilterGet({
        Service: "obirimbelge",
        Page: this.Page,
        Filter: FilterText,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">


                <div class="col-sm-10 row">

                  <b-form-group class="col-lg-3" label="Başlık">
                    <b-form-input v-model="Filter.Baslik" type="text"></b-form-input>
                  </b-form-group>




                  <b-form-group class="col-lg-3" label-for="text" label="Kurum" :key="Filter.Birimid">
                    <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray"
                      placeholder="Seçiniz..." v-model="Filter.Birimid" />
                    <treeselect-value :value="Filter.Birimid" />
                  </b-form-group>




                  <div class="col-lg-3 mt-4">
                    <button class="btn btn-success  " data-bs-dismiss="offcanvas" type="button" data-bs-target="#demo"
                      @click="Page.PageNumber = 1, Get()">
                      Filtreleme
                    </button>
                  </div>

                </div>
                <div class="col-sm-2">
                  <div class="text-sm-end">


                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.obirimbelge
                      @click="(DataUpdate = obirimbelgeData), (AddEdit = 'Add')">
                      <i class="mdi mdi-plus me-1"></i>
                      Yeni Kayıt Ekle
                    </button>

                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Kurum</th>
                      <th>Başlık</th>
                      <th>Dosya</th>
                      <th class="text-center">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Birimadi }}</th>
                      <td>{{ Data.Baslik }}</td>

                      <td>  
                        <a target="_blank" :href="FILES_URL + '/Tlp/' + Data.Dosyayolu" v-if=" Data.Dosyayolu">
                              Görüntülemek İçin Tıklayın </a> 

                      </td>
                      <td>
                        <div class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          ">
                          <b-button-group>
                            <b-button v-b-tooltip.hover title="Düzenle" variant="success" v-b-modal.obirimbelge
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                            <b-button variant="danger" v-b-tooltip.hover title="Sil"
                              @click="Delete('obirimbelge', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
